export const experimentTester = {
  drawerTitle: "Experiment Tester",

  tabs: {
    abTests: "A/B Tests",
    flippers: "Flippers",
  },

  abTests: {
    experiments: "Experiments",
    group: "Group",
    persistGroups: "Persist groups",
  },

  flippers: {
    searchLabel: "Search for flipper(s)",
    loadingMessage: "Loading loading loading, keep the flippers loading, show/hide!",
    tableHeader: "Flippers",
    statusHeader: "Status",
    reset: "Reset",
    resetAriaLabel: "Reset the flippers to the production state",
    sync: "Sync",
    syncAriaLabel: "Sync the flippers to the production state",
  },

  flipper: {
    recent: "Recent",
    recentTooltip: "This flipper was recently enabled locally",
    exposeTooltip:
      "This will close the drawer and expose the flipper toggle inside a toast instead.",
    exposeAriaLabel: "Expose flipper toggle inside toast",
    copyTooltip: "Copy flipper name",
    copyAriaLabel: "Copy flipper name",
    on: "On",
    off: "Off",
  },

  flipperToast: {
    status: "Status:",
    enabled: "Enabled",
    disabled: "Disabled",
  },
} as const;
